import { render, staticRenderFns } from "./DropdownClosebtn.vue?vue&type=template&id=1c5c5cba&"
import script from "./DropdownClosebtn.vue?vue&type=script&lang=js&"
export * from "./DropdownClosebtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports